/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_IsbnInputs */

const en_field_isbn = /** @type {(inputs: Field_IsbnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISBN (if applicable)`)
};

const es_field_isbn = /** @type {(inputs: Field_IsbnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISBN (si corresponde)`)
};

const fr_field_isbn = /** @type {(inputs: Field_IsbnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISBN (si applicable)`)
};

const de_field_isbn = /** @type {(inputs: Field_IsbnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISBN (falls zutreffend)`)
};

const ja_field_isbn = /** @type {(inputs: Field_IsbnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISBN (該当する場合)`)
};

const zh_field_isbn = /** @type {(inputs: Field_IsbnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISBN (如适用)`)
};

const ar_field_isbn = /** @type {(inputs: Field_IsbnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رقم ISBN (إن وجد)`)
};

const id_field_isbn = /** @type {(inputs: Field_IsbnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISBN (jika ada)`)
};

const it_field_isbn = /** @type {(inputs: Field_IsbnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISBN (se applicabile)`)
};

const ru_field_isbn = /** @type {(inputs: Field_IsbnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISBN (если применимо)`)
};

const pt_field_isbn = /** @type {(inputs: Field_IsbnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISBN (se aplicável)`)
};

const ko_field_isbn = /** @type {(inputs: Field_IsbnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ISBN (해당하는 경우)`)
};

/**
* | output |
* | --- |
* | "ISBN (if applicable)" |
*
* @param {Field_IsbnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_isbn = /** @type {((inputs?: Field_IsbnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_IsbnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_isbn(inputs)
	if (locale === "es") return es_field_isbn(inputs)
	if (locale === "fr") return fr_field_isbn(inputs)
	if (locale === "de") return de_field_isbn(inputs)
	if (locale === "ja") return ja_field_isbn(inputs)
	if (locale === "zh") return zh_field_isbn(inputs)
	if (locale === "ar") return ar_field_isbn(inputs)
	if (locale === "id") return id_field_isbn(inputs)
	if (locale === "it") return it_field_isbn(inputs)
	if (locale === "ru") return ru_field_isbn(inputs)
	if (locale === "pt") return pt_field_isbn(inputs)
	return ko_field_isbn(inputs)
});